"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _inputTypes = _interopRequireDefault(require("./constants/inputTypes"));

var _CheckInput = _interopRequireDefault(require("./fields/CheckInput"));

var _FormButton = _interopRequireDefault(require("./fields/FormButton"));

var _NumberFormatInput = _interopRequireDefault(require("./fields/NumberFormatInput"));

var _RadioInput = _interopRequireDefault(require("./fields/RadioInput"));

var _SelectInput = _interopRequireDefault(require("./fields/SelectInput"));

var _SliderInput = _interopRequireDefault(require("./fields/SliderInput"));

var _TextAreaInput = _interopRequireDefault(require("./fields/TextAreaInput"));

var _TextInput = _interopRequireDefault(require("./fields/TextInput"));

var _DateSelector = _interopRequireDefault(require("./fields/DateSelector"));

var _CreditCard = _interopRequireDefault(require("./fields/CreditCard"));

var _CompanyLookup = _interopRequireDefault(require("./fields/CompanyLookup"));

var _Iban = _interopRequireDefault(require("./fields/Iban"));

var _SortCode = _interopRequireDefault(require("./fields/SortCode"));

var _Bic = _interopRequireDefault(require("./fields/Bic"));

var _lodash = require("lodash");

var _NumberRange = _interopRequireDefault(require("./fields/NumberRange"));

var _RichTextInput = _interopRequireDefault(require("./fields/RichTextInput"));

var _SelectCreateInput = _interopRequireDefault(require("./fields/SelectCreateInput"));

var _CurrencyInput = _interopRequireDefault(require("./fields/CurrencyInput"));

var _PhoneInput = _interopRequireDefault(require("./fields/PhoneInput"));

var _excluded = ["component"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputBox = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), function (props) {
  return props.externalCss;
});

var InputSelector = function InputSelector(_ref) {
  var fieldConfig = _ref.fieldConfig,
      inputChangedHandler = _ref.inputChangedHandler,
      value = _ref.value,
      handleKeyPress = _ref.handleKeyPress,
      selectScrollEnd = _ref.selectScrollEnd,
      extraValues = _ref.extraValues,
      handleNext = _ref.handleNext,
      formattingOptions = _ref.formattingOptions,
      _ref$formErrors = _ref.formErrors,
      formErrors = _ref$formErrors === void 0 ? {} : _ref$formErrors,
      buttonClickHandlers = _ref.buttonClickHandlers,
      companyLookUpInstructions = _ref.companyLookUpInstructions,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      visible = _ref.visible,
      errorHandler = _ref.errorHandler,
      noFocus = _ref.noFocus,
      validationDependency = _ref.validationDependency,
      disabled = _ref.disabled,
      options = _ref.options,
      sliderMax = _ref.sliderMax,
      cleanValues = _ref.cleanValues,
      isFirstInput = _ref.isFirstInput,
      isLoading = _ref.isLoading,
      _ref$customValidation = _ref.customValidations,
      customValidations = _ref$customValidation === void 0 ? {} : _ref$customValidation,
      postErrors = _ref.postErrors,
      postErrorHandler = _ref.postErrorHandler,
      formOptions = _ref.formOptions,
      _ref$t = _ref.t,
      t = _ref$t === void 0 ? function (k) {
    return k;
  } : _ref$t;
  (0, _react.useEffect)(function () {
    if (!visible) {
      errorHandler(_defineProperty({}, fieldConfig.id, []));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [visible, fieldConfig.id]);

  var renderInput = function renderInput(field) {
    var _field$options, _field$options2, _field$options3, _field$options4, _field$options5, _field$options6, _field$options7;

    var moveToNextStep = function moveToNextStep(e) {
      if (e.keyCode === 9 && (0, _lodash.isEmpty)(formErrors)) {
        e.preventDefault();
        handleNext();
      }
    };

    var element = null;

    var elementProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      key: field.id,
      isFirstInput: isFirstInput,
      id: field.id,
      customLabel: t(field.labelTranslationId || field.label || field.id),
      label: t(field.label || field.id),
      customValidations: customValidations,
      value: value,
      errors: errors,
      formattingOptions: formattingOptions,
      onChange: inputChangedHandler,
      dependencies: field.dependencies,
      visible: visible,
      errorHandler: errorHandler,
      postErrors: postErrors,
      postErrorHandler: postErrorHandler,
      noFocus: noFocus,
      extraValues: extraValues,
      customPlaceholder: fieldConfig.placeholder || field.customPlaceHolder || "",
      min: field.min,
      max: field.max,
      maxLength: field.maxLength,
      minLength: field.minLength,
      regex: field.validation,
      regexError: field.validationMessage,
      minRows: field.minRows,
      t: t,
      handleKeyPress: handleKeyPress || handleNext && moveToNextStep
    }, isLoading ? {
      isLoading: isLoading
    } : {}), field.currency && {
      currency: field.currency
    }), disabled && {
      disabled: disabled
    }), fieldConfig.validations && {
      validations: fieldConfig.validations
    }), validationDependency && {
      validationDependency: validationDependency
    }), field.isOpen && {
      isOpen: field.isOpen
    }), field.debounceTiming && {
      debounceTiming: field.debounceTiming
    }), field.isAsync && {
      isAsync: field.isAsync
    }), field.customLabel && {
      customLabel: field.customLabel
    }), field.options && {
      options: field.options
    }), formOptions !== null && formOptions !== void 0 && formOptions.labelTooltip ? {
      labelTooltip: field.description
    } : {
      fieldDescription: field.description
    });

    switch (field.type) {
      case _inputTypes.default.inputText:
      default:
        element = _TextInput.default;
        elementProps = _objectSpread({}, elementProps);
        break;

      case _inputTypes.default.textArea:
        element = _TextAreaInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          type: 'textarea',
          handleKeyPress: handleKeyPress
        });
        break;

      case _inputTypes.default.inputNumber:
        element = _NumberFormatInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          type: 'number',
          endAdornment: field.endAdornment
        });
        break;

      case _inputTypes.default.numberRange:
        element = _NumberRange.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          type: 'number',
          endAdornment: field.endAdornment
        });
        break;

      case _inputTypes.default.email:
        element = _TextInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          emailValidation: true
        });
        break;

      case _inputTypes.default.telephone:
        element = _PhoneInput.default;
        elementProps = _objectSpread({}, elementProps);
        break;

      case _inputTypes.default.iban:
        element = _Iban.default;
        elementProps = _objectSpread({}, elementProps);
        break;

      case _inputTypes.default.bic:
        element = _Bic.default;
        elementProps = _objectSpread({}, elementProps);
        break;

      case _inputTypes.default.sortCode:
        element = _SortCode.default;
        elementProps = _objectSpread({}, elementProps);
        break;

      case _inputTypes.default.select:
        element = _SelectInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          options: field.customOptions || options[field.options],
          isMulti: field.isMulti,
          selectScrollEnd: selectScrollEnd,
          menuPlacement: field.menuPlacement,
          closeMenuOnScroll: field.closeMenuOnScroll,
          requiredSelection: (_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.requiredSelection,
          requiredSelectionErrorMessage: (_field$options2 = field.options) === null || _field$options2 === void 0 ? void 0 : _field$options2.requiredSelectionErrorMessage
        });
        break;

      case _inputTypes.default.selectCreate:
        element = _SelectCreateInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          options: field.customOptions || options[field.options],
          checkValidCreatable: field.checkValidCreatable,
          selectScrollEnd: selectScrollEnd,
          menuPlacement: field.menuPlacement,
          closeMenuOnScroll: field.closeMenuOnScroll
        });
        break;

      case _inputTypes.default.radio:
        element = _RadioInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          options: field.customOptions || options[field.options],
          requiredSelection: (_field$options3 = field.options) === null || _field$options3 === void 0 ? void 0 : _field$options3.requiredSelection,
          requiredSelectionErrorMessage: (_field$options4 = field.options) === null || _field$options4 === void 0 ? void 0 : _field$options4.requiredSelectionErrorMessage
        });
        break;

      case _inputTypes.default.check:
        element = _CheckInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          requiredSelection: (_field$options5 = field.options) === null || _field$options5 === void 0 ? void 0 : _field$options5.requiredSelection,
          requiredSelectionErrorMessage: (_field$options6 = field.options) === null || _field$options6 === void 0 ? void 0 : _field$options6.requiredSelectionErrorMessage
        });
        break;

      case _inputTypes.default.slider:
        element = _SliderInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          min: field.min,
          max: field.max || sliderMax,
          postfix: field.postfix
        });
        break;

      case _inputTypes.default.numberFormat:
        element = _NumberFormatInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          type: 'number'
        });
        break;

      case _inputTypes.default.date:
        element = field.dateFormat === 'YEAR' ? _TextInput.default : _DateSelector.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          typeOfDate: field.dateFormat === 'MONTH' ? 'month' : 'date',
          dateRange: (_field$options7 = field.options) === null || _field$options7 === void 0 ? void 0 : _field$options7.dateRange
        });
        break;

      case _inputTypes.default.button:
        element = _FormButton.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          value: elementProps.customLabel || elementProps.label,
          buttonClickHandler: buttonClickHandlers[field.id]
        });
        break;

      case _inputTypes.default.richText:
        element = _RichTextInput.default;
        elementProps = _objectSpread({}, elementProps);
        break;

      case _inputTypes.default.creditCard:
        element = _CreditCard.default;
        break;

      case _inputTypes.default.companyLookup:
        element = _CompanyLookup.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          options: options[field.options],
          selectScrollEnd: selectScrollEnd,
          cleanValues: cleanValues,
          companyLookUpInstructions: companyLookUpInstructions,
          t: t
        });
        break;

      case _inputTypes.default.currency:
        element = _CurrencyInput.default;
        elementProps = _objectSpread(_objectSpread({}, elementProps), {}, {
          options: field.customOptions || options[field.options]
        });
        break;

      case _inputTypes.default.extensionCustomInputs:
        var component = field.component,
            customProps = _objectWithoutProperties(field, _excluded);

        element = field.component;
        elementProps = _objectSpread(_objectSpread({}, elementProps), customProps);
    }

    return _react.default.createElement(element, elementProps);
  };

  return visible ? _react.default.createElement(InputBox, {
    "data-cy": "form-".concat(fieldConfig.id),
    externalCss: fieldConfig.styles && fieldConfig.styles.input
  }, renderInput(fieldConfig)) : null;
};

var _default = (0, _react.memo)(InputSelector);

exports.default = _default;